import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import InstallPrompt from "@/components/InstallPrompt";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import LiveMap from "@/pages/LiveMap";
import FarmProfile from "@/pages/FarmProfile";
import SellerRegister from "@/pages/SellerRegister";
import OnboardingAssistant from "@/pages/OnboardingAssistant";
import SellerDashboard from "@/pages/SellerDashboard";
import Billing from "@/pages/Billing";
import Cart from "@/pages/Cart";
import MyOrders from "@/pages/MyOrders";
import Auth from "@/pages/Auth";
import AdminPanel from "@/pages/AdminPanel";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/map" element={<LiveMap />} />
              <Route path="/farms/:id" element={<FarmProfile />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/sell/register" element={<ProtectedRoute><SellerRegister /></ProtectedRoute>} />
              <Route path="/sell/assistant" element={<OnboardingAssistant />} />
              <Route path="/sell/dashboard" element={<ProtectedRoute><SellerDashboard /></ProtectedRoute>} />
              <Route path="/sell/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
              <Route path="/my-orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
            </Routes>
            <Toaster position="top-center" richColors />
            <InstallPrompt />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
